// import React, { useEffect, useState } from "react";


// function ProductsResume (props) {

//     const [freeDelivery, setFreeDelivery] = useState(false);
//     const [totalProducts, setTotalProducts] = useState(null);
//     const [total, setTotal] = useState();

//     useEffect(() => {
//         //if total quantity is >= 4, then change applyDiscount to true
//         let total_quantity = 0;
//         for (let i = 0; i < props.items.length; i++) {
//             total_quantity += props.items[i].quantity;
//         }
//         if (total_quantity >= process.env.REACT_APP_KILOS_NUMBER_DISCOUNT) {
//             setFreeDelivery(true);
//         } else {
//             setFreeDelivery(false);
//         }
//         calculateTotalPrices(total_quantity);
//     }, [props.items]);

//     function calculateTotalPrices (total_quantity) {
//         let totalProducts = 0;
//         for (let i = 0; i < props.items.length; i++) {
//             totalProducts += props.items[i].total;
//         }
//         setTotalProducts(totalProducts);
//         if (total_quantity >= process.env.REACT_APP_KILOS_NUMBER_DISCOUNT) {
//             setTotal(Number(totalProducts));
//         } else {
//             setTotal(Number(totalProducts) + Number(process.env.REACT_APP_DELIVERY_FEE));
//         }
//     }

//     return(
//         <div className="bg-slate-50 py-5">
//             <div className="font-bold text-2xl px-4 text-gray-600 mb-3 text-center">
//                 <p>Ítems en el Carrito</p>
//             </div>
//             <table className="w-full text-center">
//                 <thead className="text-gray-600 uppercase">
//                     <tr>
//                         <th>Producto</th>
//                         <th>Cantidad</th>
//                         <th>Subtotal</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {props.items.map((item) =>
//                         <tr key={item.product.id} className="text-gray-500">
//                             <td>{item.product.name}</td>
//                             <td>{item.quantity} {item.product.type}</td>
//                             <td>${item.total.toLocaleString().replace(/,/g, '.')}</td>
//                         </tr>
//                     )}
//                 </tbody>
//             </table>
//             <div className="font-bold text-gray-500 text-center mt-3 uppercase">
//                 { freeDelivery ? (
//                     <div>
//                         <div>
//                             <p className="text-gray-600">Total Productos: ${totalProducts.toLocaleString().replace(/,/g, '.')}</p>
//                         </div>
//                         <div>
//                             <p className="text-gray-600">Despacho: gratis</p>
//                         </div>
//                         <div>
//                             <p className="text-gray-600">Total a Pagar: ${total.toLocaleString().replace(/,/g, '.')}</p>
//                         </div>
//                     </div>
//                     ) : totalProducts  ? (
//                     <>
//                         <div className="text-gray-600 text-bold">
//                             <p>Total Productos: ${totalProducts.toLocaleString().replace(/,/g, '.')}</p>
//                         </div>
//                         <div>
//                             <p className="text-gray-600">Despacho: ${Number(process.env.REACT_APP_DELIVERY_FEE).toLocaleString().replace(/,/g, '.')}</p>
//                         </div>
//                         <div>
//                             <p className="text-gray-600">Total a Pagar: ${total.toLocaleString().replace(/,/g, '.')}</p>
//                         </div>
//                     </>
//                     ) : (
//                         null
//                     )
//                 }
//             </div>
//         </div>
//     )
// }

// export default ProductsResume;


import React, { useEffect, useState } from "react";

function ProductsResume(props) {

    const [freeDelivery, setFreeDelivery] = useState(false);
    const [totalProducts, setTotalProducts] = useState(null);
    const [total, setTotal] = useState(null);

    const fmt = (n) => `$${Number(n).toLocaleString().replace(/,/g, ".")}`;

    useEffect(() => {
        let total_amount_cart = 0;
        for (let i = 0; i < props.items.length; i++) {
            total_amount_cart += props.items[i].total;
        }
        setTotalProducts(total_amount_cart);
        if (total_amount_cart >= Number(process.env.REACT_APP_FREE_DELIVERY_AMOUNT)) {
            setFreeDelivery(true);
            setTotal(total_amount_cart);
        } else {
            setFreeDelivery(false);
            setTotal(total_amount_cart + Number(process.env.REACT_APP_DELIVERY_FEE));
        }
    }, [props.items]);

    return (
        <div className="mx-3 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">

            {/* Header */}
            <div className="px-4 py-3 flex items-center gap-2 border-b border-gray-100 bg-[#fdf7ef]">
                <svg className="w-4 h-4 text-[#0f4a4e] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                </svg>
                <p className="text-sm font-semibold text-[#1a1f1a]">Tu pedido</p>
                <span className="ml-auto text-[11px] text-[#0f4a4e] font-semibold bg-[#e8f0f0] px-2.5 py-0.5 rounded-full">
                    {props.items.length} {props.items.length === 1 ? "producto" : "productos"}
                </span>
            </div>

            {/* Items */}
            <div className="divide-y divide-gray-50">
                {props.items.map((item) => (
                    <div key={item.product.id} className="flex items-center px-4 py-2.5 gap-3">
                        <div className="w-9 h-9 rounded-xl bg-[#f0f7f7] flex items-center justify-center flex-shrink-0 overflow-hidden">
                            {item.product.imageUrl ? (
                                <img src={item.product.imageUrl} alt={item.product.name} className="w-full h-full object-contain p-1" />
                            ) : (
                                <span className="text-sm">🌿</span>
                            )}
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-[13px] font-medium text-[#1a1f1a] truncate">{item.product.name}</p>
                            <p className="text-[11px] text-gray-400">{item.quantity} × {item.product.type}</p>
                        </div>
                        <p className="text-[13px] font-semibold text-[#1a1f1a] flex-shrink-0">
                            {fmt(item.total)}
                        </p>
                    </div>
                ))}
            </div>

            {/* Totales */}
            {totalProducts !== null && (
                <div className="px-4 py-3 border-t border-gray-100 bg-[#fdf7ef] flex flex-col gap-2">
                    <div className="flex justify-between items-center">
                        <span className="text-xs text-gray-400">Subtotal productos</span>
                        <span className="text-xs text-gray-600 font-medium">{fmt(totalProducts)}</span>
                    </div>
                    <div className="flex justify-between items-center">
                        <span className="text-xs text-gray-400">Despacho</span>
                        {freeDelivery ? (
                            <span className="text-[11px] font-semibold text-[#0f4a4e] bg-[#e8f0f0] px-2 py-0.5 rounded-full">
                                Gratis ✓
                            </span>
                        ) : (
                            <span className="text-xs text-gray-600 font-medium">
                                {fmt(process.env.REACT_APP_DELIVERY_FEE)}
                            </span>
                        )}
                    </div>
                    <div className="flex justify-between items-center pt-2 border-t border-gray-200 mt-1">
                        <span className="text-[13px] font-semibold text-[#1a1f1a]">Total a pagar</span>
                        <span className="text-[16px] font-bold text-[#0f4a4e]">{fmt(total)}</span>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ProductsResume;